let RecordingUtil = require("../util/RecordingUtil");

let {
  Drop,
  IconButton,
  Calendar
} = mc.widgets;

let RecordingCalendar = function (props) {
  let {
    recordings,
    ts,
    tz,
    tooltip,
    onSelect
  } = props;

  let sessions = RecordingUtil.sessions(recordings);

  let data = RecordingUtil.calendar(sessions, tz).map(function (d) {
    return {
      ts: d.dayStartMsUtc,
      ref: d.recStartTs,
      value: d.wearTimeMillis / mc.math.MILLIS_PER_DAY
    };
  });

  let tzInfo = mc.tz.info(ts, tz, "DAY_START");

  return (
    <Drop align="right">
      <IconButton
        id="rc-calendar-button"
        icon="calendar"
        label={tooltip}
        disabled={data.length === 0}
        scale={1.2}/>
      <div className="mc-drop-content" style={{ maxWidth: 800 }}>
        <Calendar
          data={data}
          ts={ts ? (tzInfo.value + tzInfo.offset) : null}
          tz={tz}
          onSelect={onSelect}/>
      </div>
    </Drop>
  );
};

module.exports = RecordingCalendar;